module.exports = __webpack_public_path__ + "static/media/user-dropdown-profile.e7207182.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/user-dropdown-profile.svg
// module id = 1589
// module chunks = 0